


import { Application, Housing } from '@/models';
import { API_URL, FetchApi } from './service';


const URI = `${API_URL}/core/applications/`;



export const ApplicationServices = {


  create: (data: Partial<Application>) =>
    FetchApi.postFile(`${URI}`, data),


  get: (id: number) =>
    FetchApi.get(`${URI}${id}/`),


  

  my_applications: (params?: any) =>
      FetchApi.get(`${URI}my-applications/?${new URLSearchParams(params).toString()}`),


  new_applications: (params?: any) =>
      FetchApi.get(`${URI}new-applications/?${new URLSearchParams(params).toString()}`),


  pending_applications: (params?: any) =>
      FetchApi.get(`${URI}pending-applications/?${new URLSearchParams(params).toString()}`),
  
  
  verified_applications: (params?: any) =>
      FetchApi.get(`${URI}verified-applications/?${new URLSearchParams(params).toString()}`),


  preselected_applications: (params?: any) =>
      FetchApi.get(`${URI}preselected-applications/?${new URLSearchParams(params).toString()}`),
  
  
  scored_applications: (params?: any) =>
      FetchApi.get(`${URI}scored-applications/?${new URLSearchParams(params).toString()}`),

  update: (id: number, data: Partial<Application>) =>
    FetchApi.putFile(`${URI}${id}/`, data),


  askDocuments: (id: number, data: any) =>
    FetchApi.put(`${URI}${id}/ask-documents/`, data),


  verify: (id: number, data: Partial<Application>) =>
    FetchApi.put(`${URI}${id}/complete-verification/`, data),
  
  
  pre_select: (id: number, data: Partial<Application>) =>
    FetchApi.put(`${URI}${id}/preselect-application/`, data),


  completeVerification: (id: number, data: { answer: string; notes: string }) =>
    FetchApi.put(`${URI}${id}/respond-to-verification/`, data),
  
  completeManagerVerification: (id: number, data: { answer: string; notes: string }) =>
    FetchApi.put(`${URI}${id}/manager-verification/`, data),

  reject: (id: number, data: Partial<Application>) =>
    FetchApi.put(`${URI}${id}/reject/`, data),



  delete: (id: number) =>
    FetchApi.delete(`${URI}${id}/`),



};
